(function () {
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function headerOffset() {
    const sticky = document.querySelector('sticky-header');
    if (sticky) return sticky.offsetHeight + 16;
    const header = document.querySelector('.section-header') || document.querySelector('header');
    return (header ? header.offsetHeight : 0) + 16;
  }

  function targetScrollTop(target) {
    return target.getBoundingClientRect().top + window.scrollY - headerOffset();
  }

  function smoothScrollTo(target) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      window.scrollTo(0, targetScrollTop(target));
      return;
    }

    const start = window.scrollY;
    const initialDistance = targetScrollTop(target) - start;
    if (Math.abs(initialDistance) < 2) return;

    const duration = Math.min(1100, Math.max(480, Math.abs(initialDistance) * 0.55));
    let startTime = null;

    function frame(now) {
      if (startTime == null) startTime = now;
      const progress = Math.min(1, (now - startTime) / duration);
      // Recalculate each frame — header compact mid-scroll shifts the destination
      const destination = targetScrollTop(target);
      window.scrollTo(0, start + (destination - start) * easeInOutCubic(progress));
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        window.scrollTo(0, targetScrollTop(target));
        // Settle after header compact transition finishes
        window.setTimeout(function () {
          window.scrollTo(0, targetScrollTop(target));
        }, 380);
      }
    }

    requestAnimationFrame(frame);
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-vibe-smooth-scroll]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;

    const target = document.querySelector(href);
    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', href);
    smoothScrollTo(target);
  });

  function init(root) {
    if (!root || root.dataset.videoReady === 'true') return;
    const videos = Array.from(root.querySelectorAll('[data-vibe-hero-video]'));
    if (videos.length < 2) return;

    root.dataset.videoReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const isMobile =
      window.matchMedia('(max-width: 989px)').matches ||
      window.matchMedia('(hover: none)').matches ||
      window.matchMedia('(pointer: coarse)').matches;

    if (reduceMotion.matches || isMobile) {
      videos.forEach(function (video) {
        video.removeAttribute('autoplay');
        video.removeAttribute('src');
        video.removeAttribute('data-src');
        try {
          video.load();
        } catch (err) {}
        video.pause();
      });
      return;
    }

    let activeIndex = 0;
    let switching = false;
    let primedIndex = -1;

    function prepVideo(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.loop = false;
    }

    /** Lazy: attach src only when a clip is about to play. */
    function ensureSrc(video) {
      if (!video) return;
      var dataSrc = video.getAttribute('data-src');
      if (!dataSrc) return;
      var current = video.getAttribute('src') || '';
      if (current === dataSrc) return;
      video.src = dataSrc;
      try {
        video.load();
      } catch (err) {}
    }

    videos.forEach(function (video, i) {
      prepVideo(video);
      if (i === 0) {
        video.classList.add('is-active');
      } else {
        video.classList.remove('is-active');
        video.pause();
      }
    });

    function tryPlay(video) {
      if (!video) return Promise.resolve();
      ensureSrc(video);
      prepVideo(video);
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        return playPromise.catch(function () {});
      }
      return Promise.resolve();
    }

    function playActive() {
      tryPlay(videos[activeIndex]);
    }

    function whenPlaying(video, timeoutMs) {
      return new Promise(function (resolve) {
        if (!video) {
          resolve();
          return;
        }
        if (!video.paused && video.currentTime > 0.02 && video.readyState >= 2) {
          resolve();
          return;
        }

        var done = false;
        function finish() {
          if (done) return;
          done = true;
          video.removeEventListener('playing', onPlaying);
          video.removeEventListener('timeupdate', onTick);
          window.clearTimeout(timer);
          resolve();
        }
        function onPlaying() {
          finish();
        }
        function onTick() {
          if (!video.paused && video.currentTime > 0.02) finish();
        }

        video.addEventListener('playing', onPlaying);
        video.addEventListener('timeupdate', onTick);
        var timer = window.setTimeout(finish, timeoutMs || 2000);
        tryPlay(video);
      });
    }

    function seekToStart(video) {
      return new Promise(function (resolve) {
        if (!video) {
          resolve();
          return;
        }
        if (video.currentTime <= 0.05) {
          resolve();
          return;
        }
        var settled = false;
        function finish() {
          if (settled) return;
          settled = true;
          video.removeEventListener('seeked', finish);
          window.clearTimeout(timer);
          resolve();
        }
        video.addEventListener('seeked', finish);
        var timer = window.setTimeout(finish, 600);
        try {
          video.currentTime = 0;
        } catch (err) {
          finish();
        }
      });
    }

    /** Start next clip under opacity 0 so decode/buffer is ready before fade. */
    function primeNext(nextIndex) {
      if (nextIndex === activeIndex || nextIndex === primedIndex) return;
      var next = videos[nextIndex];
      if (!next) return;
      primedIndex = nextIndex;
      ensureSrc(next);
      seekToStart(next).then(function () {
        if (primedIndex !== nextIndex || switching) return;
        tryPlay(next);
      });
    }

    function crossfadeTo(nextIndex) {
      if (switching || nextIndex === activeIndex) return;
      switching = true;

      var current = videos[activeIndex];
      var next = videos[nextIndex];
      ensureSrc(next);

      var alreadyPrimed =
        primedIndex === nextIndex && !next.paused && next.currentTime > 0.02 && next.readyState >= 2;

      var prepare = alreadyPrimed
        ? Promise.resolve()
        : seekToStart(next).then(function () {
            return whenPlaying(next, 2200);
          });

      prepare.then(function () {
        var media = root.querySelector('.vibe-home__media');
        if (media) media.classList.add('is-crossfading');
        next.classList.add('is-active');
        current.classList.remove('is-active');

        window.setTimeout(function () {
          if (media) media.classList.remove('is-crossfading');
          if (current !== videos[nextIndex]) {
            current.pause();
            try {
              current.currentTime = 0;
            } catch (err) {}
          }
          activeIndex = nextIndex;
          primedIndex = -1;
          switching = false;
        }, 900);
      });
    }

    videos.forEach(function (video, i) {
      video.addEventListener('timeupdate', function () {
        if (switching || i !== activeIndex) return;
        if (!video.duration || !isFinite(video.duration)) return;

        var remaining = video.duration - video.currentTime;
        // Start next under the fade (~0.9s left) so mobile has time to decode
        if (remaining <= 0.95 && remaining > 0.4) {
          primeNext((activeIndex + 1) % videos.length);
        }
        if (remaining > 0.35) return;
        crossfadeTo((activeIndex + 1) % videos.length);
      });

      video.addEventListener('ended', function () {
        if (i !== activeIndex || switching) return;
        crossfadeTo((activeIndex + 1) % videos.length);
      });
    });

    playActive();
    // Don't pre-warm too early — iOS often stalls dual playback; prime near clip end only.

    // iOS / mobile: retry muted autoplay after first gesture or when tab is visible
    function resumeIfNeeded() {
      var active = videos[activeIndex];
      if (!active || !active.paused) return;
      playActive();
    }

    document.addEventListener('touchstart', resumeIfNeeded, { once: true, passive: true });
    document.addEventListener('click', resumeIfNeeded, { once: true });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') resumeIfNeeded();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vibe-home]').forEach(init);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector?.('[data-vibe-home]') || event.target;
    if (root && root.hasAttribute && root.hasAttribute('data-vibe-home')) {
      root.dataset.videoReady = '';
      init(root);
    } else {
      initAll();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
